import * as ThemePackTypes from './theme-packs.types';

export interface CreateVideo {
  type: 'wistia' | 'ustream' | 'embed' | 'uploaded' | 'url' | 'recorded';
  name: string;
  source: string | null;
  use_thumbnail: boolean;
  original_image: string;
  image: string;
  duration?: number;
  recording_duration_ms?: number;
  hls_link?: string;
  session_language?: string;
  captions?: VideoCaption[];
  video?: number;
  recording_id?: number;
  base_language?: string;
  // New parameters must be optional or nullable
}
export interface StaticVideo {
  uuid: string;
  channel: number;
  created_date?: Date;
  name: string;
  source: string; // This can be a URL (youtube, .m3u8, .mp4) or an embed code
  status: ModuleStatus;
  playback_url?: string;
  file_url?: string;
  duration_ms: number;
  provider: VideoProvider;
  thumbnail_url?: string;
  type: VideoType;
  convert_status: VideoConvertStatus | null; // Used for uploaded videos
  convert_progress: number | null; // Used for uploaded videos
  use_custom_thumbnail: boolean; // Used for embed/links
  original_image: string | null; // Used for embed/links
  base_language?: string;
  video_id: number | null; // Used for videos module on landing/homepage
  captions?: VideoCaption[]; // This will always be undefined or an empty array until addressed
  modified_by: number | null;
  created_by: number | null;
}

export enum ModuleStatus {
  deleted,
  active,
}

export enum VideoConvertStatus {
  progressing,
  complete,
  error,
}

export enum VideoProvider {
  ivs = 'ivs',
  mux = 'mux',
  embed = 'embed',
  uploaded = 'uploaded',
  url = 'url',
}

export enum VideoType {
  uploaded = 'uploaded',
  recorded = 'recorded',
  url = 'url',
  embed = 'embed',
}

export interface VideoCaption {
  id: number;
  uuid: string;
  created: string;
  name: string;
  video: number;
  source: string;
  language: string;
  // New parameters must be optional or nullable
  static_video_uuid?: string; // This should be backfilled and used instead of video or recording_id
}

export interface VideoPlayerControlsSettings {
  color_theme: 'default' | ThemePackTypes.EPaletteModes.Light;
}

export type VideoMap = Record<string, string>;
export type LiveVideoMap = VideoMap;
export type SecondaryVideoMap = VideoMap;

export enum DownloadRecordedRequestStatus {
  pending = 1,
  processing = 2,
  completed = 3,
  failed = 4,
}

export interface DownloadRecordedRequest {
  id?: number;
  stream_recording: string;
  status: DownloadRecordedRequestStatus;
  created_at: number;
  modified_at: number;
  email: string;
  result: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  aws_data: any;
  progress: number | null;
  channel?: number;
  // New parameters must be optional or nullable
}

export interface ArchivedVideo {
  id: number;
  name: string;
  upload_date: string | null;
  video_duration: number | null;
  url: string;
  // New parameters must be optional or nullable
}
